import 婦產手術 from 'assets/image17.jpeg'
import 醫美整形 from 'assets/image18.jpeg'
import 骨科手術 from 'assets/image19.jpeg'
import 脊椎手術 from 'assets/image20.jpeg'
import 腸胃鏡檢 from 'assets/image21.jpeg'
import 泌尿手術 from 'assets/image32.jpeg'
import 牙科治療 from 'assets/image22.jpeg'
import 植髮手術 from 'assets/image23.jpeg'
import 痔瘡瘻管 from 'assets/image24.jpeg'
import 甲腺手術 from 'assets/image25.jpeg'
import 眼科手術 from 'assets/image26.jpeg'
import 靜脈曲張 from 'assets/image27.jpeg'
import 減重手術 from 'assets/image28.jpeg'
import 乳房手術 from 'assets/image29.jpeg'
import 手汗手術 from 'assets/image30.jpeg'
import 其他手術 from 'assets/image31.jpeg'

export class SpecialtyDefine {
    id: number = 0;
    name: string = '';
    imageUrl: string = '';
    enMap: string = '';
}

const specialtyDefines : SpecialtyDefine[] = [
    {
        id: 9,
        name: '婦產手術',
        imageUrl: 婦產手術,
        enMap: 'obsgyn',
    },
    {
        id: 14,
        name: '醫美整形',
        imageUrl: 醫美整形,
        enMap: 'plastic',
    },
    {
        id: 21,
        name: '骨科手術',
        imageUrl: 骨科手術,
        enMap: 'orthopedic',
    },
    {
        id: 20,
        name: '脊椎手術',
        imageUrl: 脊椎手術,
        enMap: 'spinaloperation',
    },
    {
        id: 15,
        name: '腸胃鏡檢',
        imageUrl: 腸胃鏡檢,
        enMap: 'endoscopy',
    },
    {
        id: 34,
        name: '泌尿手術',
        imageUrl: 泌尿手術,
        enMap: 'urology',
    },
    {
        id: 36,
        name: '牙科治療',
        imageUrl: 牙科治療,
        enMap: 'dentist',
    },
    {
        id: 24,
        name: '植髮手術',
        imageUrl: 植髮手術,
        enMap: 'hairimplant',
    },
    {
        id: 35,
        name: '痔瘡瘻管',
        imageUrl: 痔瘡瘻管,
        enMap: 'hemmorhoid',
    },
    {
        id: 41,
        name: '甲腺手術',
        imageUrl: 甲腺手術,
        enMap: 'thyroid',
    },
    {
        id: 37,
        name: '眼科手術',
        imageUrl: 眼科手術,
        enMap: 'eyesurgery',
    },
    {
        id: 31,
        name: '靜脈曲張',
        imageUrl: 靜脈曲張,
        enMap: 'varicose',
    },
    {
        id: 42,
        name: '減重手術',
        imageUrl: 減重手術,
        enMap: 'bariatrics',
    },
    {
        id: 38,
        name: '乳房手術',
        imageUrl: 乳房手術,
        enMap: 'breastsurgery',
    },
    {
        id: 44,
        name: '手汗手術',
        imageUrl: 手汗手術,
        enMap: 'hyperhidrosis',
    },
    {
        id: 22,
        name: '其他手術',
        imageUrl: 其他手術,
        enMap: 'others',
    },
]

export default specialtyDefines